import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import QueryStringContext from "../../Contexts/QueryString";
import { getParameterByName } from "../../Utility/Helper";
import ReactPixel from "react-facebook-pixel";
import VisitorParamsContext from "../../Contexts/VisitorParams";

require("dotenv").config();
const FbPixel = () => {
  const history = useHistory();
  const { queryString } = useContext(QueryStringContext);
  const field = "pid";
  const { visitorParameters } = useContext(VisitorParamsContext);
  let current_domain = visitorParameters.data.existingdomain;

  if (current_domain) {
    current_domain = current_domain.replace("http://", "").replace("https://", "").split(/[/?#]/)[0];
  }
  const query = new URLSearchParams(window.location.search);
  const splitName = query.get("split_name");
  const nextPage = query.get("nextPage") ?? "";
  if (queryString != null) {

    if (queryString.indexOf("&" + field + "=") !== -1) {
      const pid = getParameterByName(field, queryString);
      if (
        current_domain === visitorParameters.data.redirectDomain ||
        // process.env.REACT_APP_URL.includes("http://localhost")
        window.location.origin.includes("http://localhost")
      ) {

        const advancedMatching = { em: "some@email.com" }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
        const options = {
          autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
          debug: false, // enable logs
        };

        ReactPixel.init(pid, advancedMatching, options);
        ReactPixel.pageView();
        ReactPixel.track("Lead");

        let uuid = visitorParameters.visitor_parameters.uuid;
        if (uuid === null || uuid === undefined) {
          uuid = query.get('uuid') ? query.get('uuid') : localStorage.getItem('uuid');
        }
        if(splitName=="MB_UFGN_1" || splitName=="MB_OBV1" || splitName=="MB_UBRF_1" || splitName=="MB_UBRF_3" || splitName=="MB_OB_UBRF_3_1"){
          history.push(
            "/signatureMB?split_name="+ splitName + "&uuid=" + uuid
          );
        }else if(splitName=="VAQ_UB_3" || splitName=="VAQ_UB_2" || splitName=="VAQ_UB_1" || splitName =="VAQ_OB_UB_3_1"){
          history.push(
            "/SignatureVAQ?split_name="+ splitName + "&uuid=" + uuid
          );
        }else if(splitName=="NDY_UB_2" || splitName=="NDY_UB_1" || splitName=="NDY_OB_UB_2_1"){
          history.push(
            "/signatureNDY?split_name="+ splitName + "&uuid=" + uuid
          );
        } else if (splitName == "VAQ_UB_4") {
          history.push(
            "/questionnaireV15?uuid=" + uuid
          );
        } else if (splitName == "VAQ_UB_4_2" || splitName == "VAQ_UB_4_3") {
          history.push(
            "/questionnaireV19?uuid=" + uuid
          );
        } else if (splitName == "MB_UFGN_4") {
        history.push(
          "/questionnaireMBGN_4?uuid=" + uuid
        );
        }
        else if (splitName == "MB_UFGN_4_1") {
          history.push(
            "/questionnaireMBGN_4_1?uuid=" + uuid
          );
        }
        else if (splitName == "NDY_UB_4" || splitName == "NDY_UB_4_2") {
          history.push(
            "/questionnaireV22?uuid=" + uuid
          );
        }
        else if (splitName == "VAQ_UB_4_3_1" || splitName == "VAQ_UB_4_3_1_B") {
          history.push(
            "/questionnaireV23?uuid=" + uuid
          );
        }
        else if (splitName == "VAQ_UB_4_3_2") {
          history.push(
            "/questionnaireV25?uuid=" + uuid
          );
        }
        else if (splitName == "NDY_UB_4_3") {
          history.push(
            "/questionnaireV26?uuid=" + uuid
          );
        }
        else if (splitName == "NDY_UB_4_4") {
          history.push(
            "/questionnaireV27?uuid=" + uuid
          );
        } else if (splitName == "VAQ_UB_4_3_1_C") {
          history.push(
            "/questionnaireV30?uuid=" + uuid
          );
        } else if (splitName == "VAQ_UB_4_3_1_D") {
          history.push(
            "/questionnaireV30?uuid=" + uuid
          );
        } else if (splitName == "VAQ_UB_5") {
          history.push(
            "/questionaireVAQV5?uuid=" + uuid
          );
        } else if (splitName == "VAQ_UB_4_3_1_C2") {
          history.push(
            "/questionnaireV31?uuid=" + uuid
          );
        } else if (splitName == "MB_UFGN_4_2") {
          history.push(
            "/questionnaireMBGN_4_2?uuid=" + uuid
          );
        } else if (splitName == "OD_UFL_4_2") {
          history.push(
            "/questionnaireV24?uuid=" + uuid
          )
        } else if (splitName == "UFC_DC_V1") {
          const creditStatus = localStorage.getItem("creditstatus");
            if(creditStatus == "Pass"){
              history.push(
              "/credit-Analyze?uuid=" + uuid
              );
            } else {
              history.push(
                "/questionaireUFC_DC_V1?uuid=" + uuid
              );
            }
        } else if (splitName == "VAQ_CCV1") {
          history.push(
            "/Credit_ConfirmVAQ_CCV1?uuid=" + uuid
          )
        } else if (splitName == "UFC_DC_V2") {
          const creditStatus = localStorage.getItem("creditstatus");
            if(creditStatus == "Pass"){
              history.push(
              "/credit-AnalyzeUFC_DC_V2?uuid=" + uuid
              );
            } else {
              history.push(
                "/questionaireUFC_DC_V2?uuid=" + uuid
              );
            }
        } else if (splitName == "UFC_DC_V2_1") {
          const creditStatus = localStorage.getItem("creditstatus");
          
            if(creditStatus == "Pass"){
              history.push(
              "/creditcheckV3?uuid=" + uuid + "&nextPage=" + nextPage
              );
            } else {
              history.push(
                "/questionaireUFC_DC_V2?uuid=" + uuid + "&nextPage=" + nextPage
              );
            }
        }  else if (splitName == "UFC_DC_V3") { 
          history.push(
            "/credit_quest_UFC_DC_V3?uuid=" + uuid
          )
        } else if (splitName == "MOCK_OD") { 
          history.push(
            "/credit_quest_MOCK_OD?uuid=" + uuid);
        } else if (splitName == "UFC_DC_V4") { 
          history.push(
            "/credit_quest_UFC_DC_V4?uuid=" + uuid
          )
        } else if (splitName == "UFC_DC_RF_V1") { 
          // history.push(
          //   `/creditcheck_UFC_DC_RF_V1?uuid=${uuid}&nextPage=${nextPage}`
          // );
          history.push(
            `/ThankyouOD_V2?uuid=${uuid}`
          );
        }  else {
        history.push(
          "/signature?split_name="+ splitName + "&uuid=" + uuid
        );
        }
        // window.location.href = full_redirect_url;
      } else {

        // const app_url = process.env.REACT_APP_URL;
        const app_url = window.location.origin;
        // const redirect_url = app_url + "thankyou";
        let uuid = visitorParameters.visitor_parameters.uuid;
        if (uuid === null || uuid === undefined) {
          uuid = query.get('uuid') ? query.get('uuid') : localStorage.getItem('uuid');
        }

        let redirect_url = '';
        redirect_url = app_url + "/signature?uuid=" + uuid;
        const advRedirectDomain = "https://" + visitorParameters.data.redirectDomain;
        // const advRedirectDomain =
        //   "https://" + visitorParameters.data.redirectDomain;
        // const fb_pixel_url =
        //   advRedirectDomain +
        //   "/fbpixel?" +
        //   queryString +
        //   "&redirect_url=" +
        //   redirect_url;
        const fb_pixel_url = advRedirectDomain + "/fbpixel?" + queryString + "&redirect_url=" + redirect_url;
        window.location.href = fb_pixel_url;

        //return false;
      }
    }
    else {
      console.log("else case");
    }
  }
  return <></>;
};

export default FbPixel;
